import React from 'react'
import { useStaticQuery, graphql, Link } from "gatsby"

import arrow from "../images/arrow.svg"

import tableOfContentStyles from "./TableOfContent.module.css"

export default function TableOfContent({ postLink }) {

    const queryData = useStaticQuery(graphql`
        query {
            allMdx {
                edges {
                  node {
                    frontmatter {
                      dir
                      post_title
                      related_links
                      table_of_content
                    }
                    fields {
                      slug
                    }
                    tableOfContents(maxDepth: 2)
                    excerpt(pruneLength: 50)
                  }
                }
              }
        }
    `)        

    // if URL is unique in the list of slugs, this is a post, otherwise it's a category title
    const isUrlPost = (url) => {
        let URLs = queryData.allMdx.edges.map( ({node}) => node.fields.slug);
        let counter = 0
        URLs.forEach(element => {
            if(element.startsWith(url)){
                counter++
            }
        })
        return counter === 1
    }    

    // get current node
    let { node } = queryData.allMdx.edges.filter( ({node}) => node.fields.slug === postLink)[0];

    // get related links
    
    let { related_links } = node.frontmatter;

    let { table_of_content } = node.frontmatter

    let relatedLinks = []
    if(related_links){
        related_links.forEach(link => {
            queryData.allMdx.edges.forEach(({node}) => {
                if(node.fields.slug === link){
                    relatedLinks.push({
                        url: link,
                        title: node.frontmatter.post_title,
                        text: node.excerpt
                    })
                }
            });
        });
    }

    const relatedLinksComponent = relatedLinks.map( (link, index) => 
        <li key={index}>
            <Link to={link.url}>
                <div className={tableOfContentStyles.postTitle}>{link.title} <img src={arrow} alt="View more..." /></div>
                <p className={tableOfContentStyles.postText}>{link.text}</p>
            </Link>
        </li>
    )


    // get page links

    let { items } = node.tableOfContents; 

    let pageLinks = []

    if(items){
        pageLinks = items
    }

    // const scrollTo = (e, target) => {

    //     e.preventDefault()

    //     // window.location.href

    //     // scroll here 
    //     // remove # from href to get actual ID
    //     let targetId = target.substring(1, target.length)                 
    //     let element = document.getElementById(targetId)
        
    //     if(element){           
    //         element.scrollIntoView({behavior: "smooth"})  
    //     }           
    // }

    const pageLinksComponent = pageLinks.map( (link, index) => 
        <li key={index}>
            {/* <a 
                // href={postLink+link.url} 
                href={link.url} 
                onClick={(e) => scrollTo(e, link.url)} 
            >
                {link.title}
            </a> */}
            <Link
                //onClick={(e) => scrollTo(e, link.url)} 
                to={link.url}
            >
                {link.title}
            </Link>            
        </li>
    )    

    // check if has related links or on page links

    return(
        <>            
            {
                isUrlPost(postLink) && table_of_content!==false && (items || related_links) && 
                    <div className={tableOfContentStyles.container}>        
                        {
                            items &&
                                <div className={tableOfContentStyles.linksBlock}>
                                    <div className={tableOfContentStyles.title}>On this page</div>
                                    <ul>
                                        {pageLinksComponent}  
                                    </ul>
                                </div>
                        }                                             
                        {
                            related_links &&
                                <div className={tableOfContentStyles.linksBlock}>
                                    <div className={tableOfContentStyles.title}>Related Articles</div>
                                    <ul>
                                        {relatedLinksComponent}  
                                    </ul>
                                </div>
                        }                        
                    </div>
            }
        </>
    )
}